var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1205_11437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.81106 6.11155C6.81106 4.34953 8.23793 2.92266 9.99994 2.92266C11.762 2.92266 13.1888 4.34953 13.1888 6.11155C13.1888 7.87356 11.762 9.30044 9.99994 9.30044C8.23793 9.30044 6.81106 7.87356 6.81106 6.11155ZM2.92217 14.8615C2.92217 14.4721 3.11169 14.0792 3.54717 13.6773C3.9874 13.271 4.63067 12.9045 5.39793 12.5971C6.93358 11.9819 8.78953 11.6727 9.99994 11.6727C11.2104 11.6727 13.0663 11.9819 14.602 12.5971C15.3692 12.9045 16.0125 13.271 16.4527 13.6773C16.8882 14.0792 17.0777 14.4721 17.0777 14.8615V17.0782H2.92217V14.8615Z",
    stroke: "#334D6E",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1205_11437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTeam);
export default __webpack_public_path__ + "static/media/manage-team.4a842fd856f52bdd8199363b4d4d81c9.svg";
export { ForwardRef as ReactComponent };